/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PaginatedR7aUrceniEditoraZpsListListResponse } from '../types/PaginatedR7aUrceniEditoraZpsListList';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type R7UrceniEditoraZpsListRequest = {} | null | undefined;
export type R7UrceniEditoraZpsListResponse = PaginatedR7aUrceniEditoraZpsListListResponse;

export type R7UrceniEditoraZpsListQuery = {
  /**
   * ```yaml
   * in: query
   * name: created__gte
   * schema:
   *   type: string
   *   format: date-time
   * ```
   */
  created__gte?: string;

  /**
   * ```yaml
   * in: query
   * name: created__lte
   * schema:
   *   type: string
   *   format: date-time
   * ```
   */
  created__lte?: string;

  /**
   * ```yaml
   * in: query
   * name: edited__gte
   * schema:
   *   type: string
   *   format: date-time
   * ```
   */
  edited__gte?: string;

  /**
   * ```yaml
   * in: query
   * name: edited__lte
   * schema:
   *   type: string
   *   format: date-time
   * ```
   */
  edited__lte?: string;

  /**
   * ```yaml
   * in: query
   * name: editor_full_name
   * schema:
   *   type: string
   * description: Editor subjekt full name
   * ```
   */
  editor_full_name?: string;

  /**
   * ```yaml
   * in: query
   * name: id_uzemni_editace__icontains
   * schema:
   *   type: string
   * ```
   */
  id_uzemni_editace__icontains?: string;

  /**
   * ```yaml
   * in: query
   * name: nazev__icontains
   * schema:
   *   type: string
   * ```
   */
  nazev__icontains?: string;

  /**
   * ```yaml
   * name: page
   * required: false
   * in: query
   * description: A page number within the paginated result set.
   * schema:
   *   type: integer
   * ```
   */
  page?: number;

  /**
   * ```yaml
   * name: page_size
   * required: false
   * in: query
   * description: Number of results to return per page.
   * schema:
   *   type: integer
   * ```
   */
  page_size?: number;

  /**
   * ```yaml
   * in: query
   * name: state__in
   * schema:
   *   type: array
   *   items:
   *     type: string
   *     enum:
   *       - CHANGE_AREA_ACCEPTED
   *       - CHANGE_AREA_RECEIVING
   *       - CHANGE_AREA_RECEIVING_FAILED
   *       - CHANGE_AREA_REJECTED
   *       - CHANGE_AREA_SENDING
   *       - CHANGE_AREA_SENDING_FAILED
   *       - PREPARED_TO_SEND
   *       - REVOKE_AREA_FAILED
   *       - SET_EDITOR_ACCEPTED
   *       - SET_EDITOR_RECEIVING
   *       - SET_EDITOR_RECEIVING_FAILED
   *       - SET_EDITOR_REJECTED
   *       - SET_EDITOR_SENDING
   *       - SET_EDITOR_SENDING_FAILED
   * description: |-
   *   * `SET_EDITOR_SENDING` - Set Editor Sending
   *   * `SET_EDITOR_SENDING_FAILED` - Set Editor Sending Failed
   *   * `SET_EDITOR_RECEIVING` - Set Editor Receiving
   *   * `SET_EDITOR_RECEIVING_FAILED` - Set Editor Receiving Failed
   *   * `SET_EDITOR_ACCEPTED` - Set Editor Accepted
   *   * `SET_EDITOR_REJECTED` - Set Editor Rejected
   *   * `PREPARED_TO_SEND` - Prepared To Send
   *   * `CHANGE_AREA_SENDING` - Change Area Sending
   *   * `CHANGE_AREA_SENDING_FAILED` - Change Area Sending Failed
   *   * `CHANGE_AREA_RECEIVING` - Change Area Receiving
   *   * `CHANGE_AREA_RECEIVING_FAILED` - Change Area Receiving Failed
   *   * `CHANGE_AREA_ACCEPTED` - Change Area Accepted
   *   * `CHANGE_AREA_REJECTED` - Change Area Rejected
   *   * `REVOKE_AREA_FAILED` - Revoke Area Failed
   * explode: true
   * style: form
   * ```
   */
  state__in?: (
    | 'CHANGE_AREA_ACCEPTED'
    | 'CHANGE_AREA_RECEIVING'
    | 'CHANGE_AREA_RECEIVING_FAILED'
    | 'CHANGE_AREA_REJECTED'
    | 'CHANGE_AREA_SENDING'
    | 'CHANGE_AREA_SENDING_FAILED'
    | 'PREPARED_TO_SEND'
    | 'REVOKE_AREA_FAILED'
    | 'SET_EDITOR_ACCEPTED'
    | 'SET_EDITOR_RECEIVING'
    | 'SET_EDITOR_RECEIVING_FAILED'
    | 'SET_EDITOR_REJECTED'
    | 'SET_EDITOR_SENDING'
    | 'SET_EDITOR_SENDING_FAILED'
  )[];

  /**
   * ```yaml
   * in: query
   * name: vyjadreni_editor
   * schema:
   *   type: integer
   * ```
   */
  vyjadreni_editor?: number;

  /**
   * ```yaml
   * in: query
   * name: vyjadreni_prijato
   * schema:
   *   type: boolean
   * ```
   */
  vyjadreni_prijato?: boolean;
};

/**
 * GET /dmx-server/r7_urceni_editora_zps/
 *
 * ```yaml
 * operationId: r7_urceni_editora_zps_list
 * tags:
 *   - r7_urceni_editora_zps
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedR7aUrceniEditoraZpsListList'
 *     description: ''
 * ```
 */
export const r7UrceniEditoraZpsListOperation = (rest?: R7UrceniEditoraZpsListQuery | null) =>
  ({
    method: 'GET',
    path: `/dmx-server/r7_urceni_editora_zps/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/r7_urceni_editora_zps/' };
  };

/**
 * GET /dmx-server/r7_urceni_editora_zps/
 *
 * ```yaml
 * operationId: r7_urceni_editora_zps_list
 * tags:
 *   - r7_urceni_editora_zps
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedR7aUrceniEditoraZpsListList'
 *     description: ''
 * ```
 */
export const r7UrceniEditoraZpsList = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: R7UrceniEditoraZpsListQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<PaginatedR7aUrceniEditoraZpsListListResponse>> => {
  const operation = r7UrceniEditoraZpsListOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/r7_urceni_editora_zps/
 */
export const useR7UrceniEditoraZpsListResource = (
  query: R7UrceniEditoraZpsListQuery | null,
  useCached?: boolean,
): UseResource<R7UrceniEditoraZpsListResponse> => {
  return useResource<R7UrceniEditoraZpsListResponse>({
    path: query === null ? null : r7UrceniEditoraZpsListOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
